// extracted by mini-css-extract-plugin
export default {"terms":"BnarL5Mzw9fJhBXuog5g","terms__content":"SFmKwzjV3i5UgDLcx6HT","terms__content__inner":"wQLFmD1VzOKOeUnr0RRy","terms__actions":"fX7b_iTviuFwbNtC18g0"};